// extracted by mini-css-extract-plugin
module.exports = {"item":"CommentItem_item__24mbD","comment-author":"CommentItem_comment-author__256pg","comment-date":"CommentItem_comment-date__3pwRe"};